import { StructuredContentRenderer } from '../renderer';
import type { NodeProps, StructuredContent } from '../types';
import { AccordionItemDetails } from './accordion-item-details';

export type AccordionItemProps = NodeProps<{
  label?: string;
  labelCollapsed?: string;
  initialStateExpanded?: boolean;
  supportsSpacing?: boolean;
  children: StructuredContent | StructuredContent[];
}>;

export function AccordionItem({ props }: AccordionItemProps) {
  if (!props.label) return null;

  return (
    <AccordionItemDetails label={props.label} initialStateExpanded={props.initialStateExpanded}>
      <StructuredContentRenderer doc={props.children} />
    </AccordionItemDetails>
  );
}
